import { lazy, Suspense } from "react";
import { ErrorBoundary } from "../components/ErrorBoundary";

const DocumentManager = lazy(
  () => import("../modules/document-manager/components/DocumentManager")
);

export function DocumentsPage() {
  return (
    <ErrorBoundary fallback={<div style={{ padding: 24 }}>Document Manager failed to load.</div>}>
      <Suspense fallback={<div className="remote-loading"><p>Loading Document Manager...</p></div>}>
        <DocumentManager />
      </Suspense>
    </ErrorBoundary>
  );
}
